function applyQuabtStyle(){  
}


function bbbuuUU(data){
  console.log(data);
}

$(document).ready(function(){
  let loadImg = '//elminorthamerica.com/cdn/shop/t/23/assets/loader.gif?v=146335725397836307021748486630';
  $('#space-product-accessories').css({'height': '100px','margin-top':'20px','outline':'1px solid #dbdde4'});
  $('#space-product-accessories').append('<div class="loaderwrap"><div><span><img src="'+loadImg+'"/><span></div></div>').fadeIn('100');
  var detectCheck = false;
  $('#spiceaddonsappid').on("DOMNodeInserted", function (event) { 
    if(detectCheck === false){
      if($(".spice_select_variant_quantity").length){
        
        $('#sg-pro-access-wrapper').load('on', function(){
            $( "input.spice_select_variant_quantity" ).attr('step', '1');
            $( "input.spice_select_variant_quantity" ).wrap("<div class='pp-quantacc'></div>");
            $( ".pp-quantacc" ).hide();
            $( ".AccessLoader" ).fadeOut();
            $( "#shopify-section-product-accessories" ).css("max-height", "inherit");
            $( "input.spice_select_variant_quantity" ).before('<span class="qnty-minus" data-quantity-change="-1"><div class="minus-sym"></div></span>');
            $( "input.spice_select_variant_quantity" ).after('<span class="qnty-plus" data-quantity-change="1"><div class="plus-sym"></div><div class="plus-sym2"></div></span>');	
              $( "input.sg-pro-access-checkbox" ).on( "click", function(e) {
                  $( this ).parents( ".sg-pro-access-product" ).find(".qnty-minus").off(qtyAccyMinus);
                  $( this ).parents( ".sg-pro-access-product" ).find(".qnty-plus").off(qtyAccPlus); 
                 if ($( this ).is(':checked')) {                                      
                  $( this ).parents( ".sg-pro-access-product" ).find( ".pp-quantacc" ).show();
                  $( this ).parents( ".sg-pro-access-product" ).find(".sg-pro-access-product-img").css("margin","0 0 0 auto");
                  $( this ).parents( ".sg-pro-access-product" ).find("img").css({"height":"65px","width":"65px"});
                  $( this ).parents( ".sg-pro-access-product" ).css({"border":"1px solid #7cb776","outline":"1px solid #7cb776"});                  
                  function qtyAccyMinus() {
                   if ($( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val() > 1) {
                       $( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val(+$( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val() - 1);
                     }
                  }

                  function qtyAccPlus() {
                   $( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val(+$( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val() + 1);
                  }                   
                  $( this ).parents( ".sg-pro-access-product" ).find(".qnty-minus").click(qtyAccyMinus);
                  $( this ).parents( ".sg-pro-access-product" ).find(".qnty-plus").click(qtyAccPlus);			
                   

                } else {
                  $( this ).parents( ".sg-pro-access-product" ).find( ".pp-quantacc" ).hide();
                  $( this ).parents( ".sg-pro-access-product" ).find(".sg-pro-access-product-img").removeAttr('style');
                  $( this ).parents( ".sg-pro-access-product" ).find("img").removeAttr('style'); 
                  $( this ).parents( ".sg-pro-access-product" ).removeAttr('style');
                  $( this ).parents( ".sg-pro-access-product" ).find(".spice_select_variant_quantity").val(1);
                }	 	
              });     
        });        
        
        
        detectCheck = true;
        setTimeout(function(){
          $('.loaderwrap').fadeOut();
          $('#space-product-accessories').removeAttr('style');
		}, 600);        
      }
    }
  });

  $( "#space-product-accessories" ).is( "#sg-pro-access-wrapper", function(){
		$( "#space-product-accessories" ).append('<div class="AccessLoader">Please wait, accessories loading...</div>');
		$( "#space-product-accessories" ).css("max-height","20px");
    });     
});


  
  
  